import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Caption } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export const SGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));
  grid-gap: 1rem;

  @media ${BREAKPOINTS.MD.min} {
    grid-gap: 1.25rem;
  }

  @media ${BREAKPOINTS.XL.min} {
    grid-gap: 1.5rem;
  }
`

export const SButton = styled(Button)`
  margin: 4.5rem auto 0;
  padding: 1rem 2rem;

  @media ${BREAKPOINTS.MD.max} {
    margin: 1.5rem auto 0;
    width: 100%;
  }
`

export const SCaption = styled(Caption)`
  margin-bottom: 1.5rem;
`
export const highlightedParagraphCss = css`
  min-height: 10rem;
  height: 1px;

  @media ${BREAKPOINTS.MD.max} {
    min-height: 8rem;
  }
`
